import React from 'react';
import moment from 'moment';
import cookie from 'react-cookies'

import theme from './ErrorPage.scss';
import {BaseDialog} from "dialogs/BaseDialog";

export default class ErrorPage extends BaseDialog {

    constructor(props) {
        super(props);

        this.state = {
            initialized: true
        };
    }

    getDialog() {
        const supportToken = cookie.load('support_token');
        const username = sessionStorage.getItem('username');
        const serverNode = this.getCookie('ROUTEID');
        return (
            <div className={theme.errorPage}>
                <span className={theme.logo}>Ein unerwarteter Fehler ist aufgetreten</span>
                <h1>Es ist ein Fehler aufgetreten...</h1>
                <h2>Wir bitten um Ihr Verständnis!</h2>
                Bitte versuchen Sie es später noch einmal. Vielen Dank!

                <h3>Support Info:</h3>

                <dl>
                    <dt>support_token:</dt>
                    <dd>{supportToken}</dd>

                    <dt>username:</dt>
                    <dd>{username}</dd>

                    <dt>server_node:</dt>
                    <dd>{serverNode}</dd>

                    <dt>timestamp:</dt>
                    <dd>{moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}</dd>
                </dl>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/ErrorPage/index.js